document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.line-floating-banner');

  if (!banner) return;

  const showOffset = 20;
  const bottomOffset = 20;

  function toggleLineBanner() {
    const scrollY = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    const isScrolled = scrollY > showOffset;
    const isBottom =
      scrollY + windowHeight >= documentHeight - bottomOffset;

    if (isScrolled && !isBottom) {
      banner.classList.add('is-show');
      banner.classList.remove('is-hide-bottom');
    } else {
      banner.classList.remove('is-show');
      banner.classList.add('is-hide-bottom');
    }
  }

  window.addEventListener('scroll', toggleLineBanner);
  window.addEventListener('resize', toggleLineBanner);

  toggleLineBanner();
});

// 画面内に入った要素を取得フェードイン
document.addEventListener('DOMContentLoaded', () => {
  const fadeElements = document.querySelectorAll('.fade-in');

  if (!fadeElements.length) return;

  if (!('IntersectionObserver' in window)) {
    fadeElements.forEach((element) => {
      element.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observerInstance.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    }
  );

  fadeElements.forEach((element) => {
    observer.observe(element);
  });
});

// 画面内に入った要素を取得フェードイン下から

document.addEventListener('DOMContentLoaded', () => {
  const fadeElements = document.querySelectorAll('.fade-up');

  if (!fadeElements.length) return;

  if (!('IntersectionObserver' in window)) {
    fadeElements.forEach((element) => {
      element.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');

          // 一度表示したら監視を終了
          observerInstance.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    }
  );

  fadeElements.forEach((element) => {
    observer.observe(element);
  });
});

